import { render, staticRenderFns } from "./TwoFaView.vue?vue&type=template&id=3bb3525a"
import script from "./TwoFaView.vue?vue&type=script&lang=js"
export * from "./TwoFaView.vue?vue&type=script&lang=js"
import style0 from "./TwoFaView.vue?vue&type=style&index=0&id=3bb3525a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports